import { render, staticRenderFns } from "./Ambrpay.vue?vue&type=template&id=00b7908c&scoped=true&"
import script from "./Ambrpay.vue?vue&type=script&lang=js&"
export * from "./Ambrpay.vue?vue&type=script&lang=js&"
import style0 from "./Ambrpay.vue?vue&type=style&index=0&id=00b7908c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7908c",
  null
  
)

export default component.exports